import { queryBuilderColors } from 'vet-bones/styles/colors';
import styles from 'vet-bones/styles/colors.scss';

export const colors = {
  connected: styles['sd-color-green'],
  darkIcon: styles['sd-color-black'],
  queryBuilderGrayId: 'sd-qb-gray',

  haloStroke: styles['sd-color-blue-1'],
  linkHandleStroke: styles['sd-color-blue-1'],
  linkHandleBackground: styles['sd-color-blue'],
  deletedOutline: styles['sd-qb-red'],
  deletedBackground: styles['sd-qb-light-orange'],
  draftOutline: styles['sd-color-blue'],
  draftBackground: styles['sd-color-gray'],
};

export const queryBuilderColorsById = queryBuilderColors.reduce<
  Record<string, string>
>((acc, { id, color }) => {
  acc[id] = color;
  return acc;
}, {});
